<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolSL_Calpak_1d01"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolSL_Calpak_1d01 from '@/device-products/ResolDeltaSolSL_Calpak_1d01.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolSL_Calpak_1d01, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
